export default [
    {
        title: 'L\'image n\'a pas été reconnue ?',
        response: 'Vérifiez votre connexion internet. Blinkl n\'envoie que peu d\'informations sur les ' +
            'images scannées mais requiert néanmoins une connexion minimale.<br><br>Si l\'image est sur un ' +
            'support très brillant, les reflets peuvent compliquer la reconnaissance.<br><br>Si l\'image ' +
            'est sur un support très déformé, comme un papier froissé, la reconnaissance est plus délicate"'
    }, {
        title: 'La caméra ne se déclenche pas ou mal ?',
        response: 'Signalez-le nous en cliquant sur le bouton "Aidez-nous"'
    }
];
